import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

import Payee from './Payee';

function PayeeList({
  payees,
  handleUpdatePayeeStatus,
  handleDeleteSuccess,
  loadingAccounts,
  usedAt
}) {
  return (
    <Stack direction="column">
      {(payees || []).map(
        (
          {
            id,
            name,
            bank,
            accountNumber,
            status,
            connectedType,
            accountType,
            fullAccountNumber,
            wire,
            isACHSupported,
            isWireSupported,
            type,
            routingNumber,
            fullRoutingNumber,
            nickname,
            firstName,
            lastName
          },
          idx
        ) => (
          <Payee
            accountNumber={accountNumber}
            accountType={accountType}
            bank={bank}
            connectedType={connectedType}
            firstName={firstName}
            fullAccountNumber={fullAccountNumber}
            fullRoutingNumber={fullRoutingNumber}
            handleDeleteSuccess={handleDeleteSuccess}
            handleUpdatePayeeStatus={handleUpdatePayeeStatus}
            id={id}
            isACHSupported={isACHSupported}
            isLatest={payees.length === idx + 1}
            isWireSupported={isWireSupported}
            key={id}
            lastName={lastName}
            loadingAccounts={loadingAccounts}
            name={name}
            nickname={nickname}
            routingNumber={routingNumber}
            status={status}
            type={type}
            usedAt={usedAt}
            wire={wire}
          />
        )
      )}
    </Stack>
  );
}

PayeeList.propTypes = {
  payees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      accountNumber: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      fullAccountNumber: PropTypes.string,
      wire: PropTypes.shape({
        address: PropTypes.shape({
          city: PropTypes.string,
          country: PropTypes.string,
          postalCode: PropTypes.string,
          state: PropTypes.string,
          street: PropTypes.string,
          street2: PropTypes.string
        }),
        routingNumber: PropTypes.string
      })
    })
  ).isRequired,
  handleUpdatePayeeStatus: PropTypes.func,
  handleDeleteSuccess: PropTypes.func,
  loadingAccounts: PropTypes.bool,
  usedAt: PropTypes.string
};

export default PayeeList;
